// extracted by mini-css-extract-plugin
export default {"container":"employee-configurations_container__rWMPB","filter_circle":"employee-configurations_filter_circle__Y-iYx"};